export const hideTrustedUserButton = () => {
  const user = JSON.parse(localStorage.getItem('auth-user'));

  return !!user?.permissions.some(
    (permission) =>
      permission.role_id === 'DASH_HIDE_TRUSTED_USER_BUTTON' &&
      !!permission.status,
  );
};
